import React, { useEffect } from 'react';
import { Translate } from '../common/WithTranslate';
import { ProgressionDialog, useProgressionDialogState } from '../common/dialog/ProgressionsDialog';
import { TLCode } from '../../common/enums';

interface PasswordResetMailConfirmationProps {
  translate: Translate;
  inProgress: boolean;
  inError: boolean;
  done: boolean;
}

export const PasswordResetMailConfirmation = ({
  translate,
  inProgress,
  inError,
  done,
}: PasswordResetMailConfirmationProps) => {
  const progressionDialogState = useProgressionDialogState();

  const doneText = translate(TLCode.LOGIN_RequestNewPasswordSent);
  const errorText = translate(TLCode.LOGIN_RequestNewPasswordError);
  const titleText = translate(TLCode.LOGIN_RequestNewPasswordProgressTitle);
  const closeButtonText = translate(TLCode.Close);

  useEffect(() => {
    if (inProgress) progressionDialogState.setInProgress();
  }, [inProgress, progressionDialogState.setInProgress]);

  useEffect(() => {
    if (inError) progressionDialogState.setInError();
  }, [inError, progressionDialogState.setInError]);

  useEffect(() => {
    if (done) progressionDialogState.setDone();
  }, [done, progressionDialogState.setDone]);

  return (
    <ProgressionDialog
      inProgress={progressionDialogState.inProgress}
      inError={progressionDialogState.inError}
      done={progressionDialogState.done}
      titleText={titleText}
      doneText={doneText}
      errorText={errorText}
      closeButtonText={closeButtonText}
      onClose={progressionDialogState.reset}
    />
  );
};
